import BaseResource from './index'
import LocationResource from './location'

export default class PackageDealGroupResource extends BaseResource {
    static endpoint = '/deals/groups'

    static related() {
        return {
            location: LocationResource,
        }
    }

    items() {
        return this.attributes.items || []
    }

    toString() {
        return this.attributes.name
    }
}
